/**
 * Onboarding contract (frontend-only).
 *
 * Constants for the mandatory 4-step onboarding wizard. The gender enum and age
 * bounds live here so the wizard, validation, and any future Account-edit screen
 * read from one source — do not hardcode these values in components.
 *
 * Backend does not branch on gender today, so this stays frontend-only (no
 * mirror in functions/). The Firestore `gender` field is stored as the option
 * `key`. If the backend ever scores on gender, promote this to a mirrored
 * contract per CLAUDE.md.
 */

// Self-reported age slider bounds. Matches the 16–80 range in the design.
export const AGE_MIN = 16;
export const AGE_MAX = 80;
export const AGE_DEFAULT = 24;

// Gender options. `key` is persisted; `label` is the display string.
export const GENDER_OPTIONS = Object.freeze([
  { key: "male", label: "Male" },
  { key: "female", label: "Female" },
  { key: "non_binary", label: "Non-binary" },
  { key: "prefer_not_to_say", label: "Prefer not to say" },
]);

export const GENDER_KEYS = Object.freeze(GENDER_OPTIONS.map((o) => o.key));

// Wizard step order. Index drives the "STEP n OF 4" label + progress dashes.
export const ONBOARDING_STEPS = Object.freeze(["age", "gender", "handle", "terms"]);
export const ONBOARDING_STEP_COUNT = ONBOARDING_STEPS.length;
